// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__GEY3m","wrapperPage":"Loading_wrapperPage__sEeu-"};